const PEAK_COUNT = 128;

export function formatVoiceDuration(ms: number, withTenths = false): string {
  const safe = Number.isFinite(ms) && ms > 0 ? ms : 0;
  const totalSeconds = Math.floor(safe / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const clock = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  if (!withTenths) return clock;

  const tenths = Math.floor((safe % 1000) / 100);
  return `${clock}.${tenths}`;
}

/** Reduces the raw samples of a decoded file to `PEAK_COUNT` normalised levels. */
export function peaksFromBuffer(buffer: AudioBuffer): number[] {
  const length = buffer.length;
  if (length === 0) return [];

  const channels = Array.from({ length: buffer.numberOfChannels }, (_, index) =>
    buffer.getChannelData(index),
  );
  const block = Math.max(1, Math.floor(length / PEAK_COUNT));
  const peaks = new Array<number>(PEAK_COUNT).fill(0);

  for (let index = 0; index < PEAK_COUNT; index += 1) {
    const start = index * block;
    const end =
      index === PEAK_COUNT - 1 ? length : Math.min(length, start + block);
    let peak = 0;

    for (let sample = start; sample < end; sample += 1) {
      for (const channel of channels) {
        const value = Math.abs(channel[sample]);
        if (value > peak) peak = value;
      }
    }

    peaks[index] = peak;
  }

  const ranked = peaks.filter((peak) => peak > 0).sort((a, b) => a - b);
  if (ranked.length === 0) return peaks;

  const loudest =
    ranked[Math.floor((ranked.length - 1) * 0.9)] || ranked[ranked.length - 1];
  if (!loudest) return peaks;

  return peaks.map((peak) => Math.min(1, (peak / loudest) ** 0.35));
}
